import * as Yup from 'yup';
export const Schema = Yup.object().shape({
  negotiated_price: Yup.boolean(),
  price: Yup.number().when('negotiated_price', {
    is: false,
    then: () => Yup.number().required('قیمت ضروری می باشد'),
    otherwise: () => Yup.number(),
  }),
});
